// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcg_a bhp_ke","ListItemIcon--empty":"bcg_b bhp_fl"};